import React from 'react';

//CRUDS - Lazy Loading
const CompanyForm = React.lazy(() => import('../pages/Company/form'));
const CompanyIndex = React.lazy(() => import('../pages/Company/index'));
const CurrencyTypeForm = React.lazy(() => import('../pages/CurrencyType/form'));
const CurrencyTypeIndex = React.lazy(() => import('../pages/CurrencyType/index'));
const Dashboard = React.lazy(() => import('../pages/Dashboard'));
const ESGSubjectForm = React.lazy(() => import('../pages/ESGSubject/form'));
const ESGSubjectIndex = React.lazy(() => import('../pages/ESGSubject/index'));
const GroupForm = React.lazy(() => import('../pages/Group/form'));
const GroupIndex = React.lazy(() => import('../pages/Group/index'));
const KPIForm = React.lazy(() => import('../pages/KPI/form'));
const KPIIndex = React.lazy(() => import('../pages/KPI/index'));
const MailNotificationDeadlineFormIndex = React.lazy(() => import('../pages/MailNotificationDeadlineForm'));
const ModuleForm = React.lazy(() => import('../pages/Module/form'));
const ModuleIndex = React.lazy(() => import('../pages/Module/index'));
const OperationForm = React.lazy(() => import('../pages/Operation/form'));
const OperationIndex = React.lazy(() => import('../pages/Operation/index'));
const ReportYearForm = React.lazy(() => import('../pages/ReportYear/form'));
const ReportYearIndex = React.lazy(() => import('../pages/ReportYear/index'));
const SectionForm = React.lazy(() => import('../pages/Section/form'));
const SectionIndex = React.lazy(() => import('../pages/Section/index'));
const SubSectionForm = React.lazy(() => import('../pages/SubSection/form'));
const SubSectionIndex = React.lazy(() => import('../pages/SubSection/index'));
const SubSectionKPIEdit = React.lazy(() => import('../pages/SubSectionKPI/edit'));
const SubSectionKPIForm = React.lazy(() => import('../pages/SubSectionKPI/form'));
const SubSectionKPIIndex = React.lazy(() => import('../pages/SubSectionKPI/index'));
const TobaccoTypeForm = React.lazy(() => import('../pages/TobaccoType/form'));
const TobaccoTypeIndex = React.lazy(() => import('../pages/TobaccoType/index'));
const UnitMeasureForm = React.lazy(() => import('../pages/UnitMeasure/form'));
const UnitMeasureIndex = React.lazy(() => import('../pages/UnitMeasure/index'));
const UserForm = React.lazy(() => import('../pages/User/form'));
const UserIndex = React.lazy(() => import('../pages/User/index'));

const MigrateDashboard = React.lazy(() => import('../pages/MigrateDashboard/index'));

//Other Pages - Lazy Loading
const AdditionalDataDeadlineFormIndex = React.lazy(() => import('../pages/AdditionalDataDeadlineForm'));
const AdditionalDataDefaultValuesForm = React.lazy(() => import('../pages/AdditionalDataDefaultValuesForm'));
const AdditionalDataTargetsFormIndex = React.lazy(() => import('../pages/AdditionalDataTargetsForm'));
const DiscussionDashboard = React.lazy(() => import('../pages/DiscussionsDashboard/index'));
const IndexFolder = React.lazy(() => import('../pages/DocumentUpload/IndexFolder'));
const Export = React.lazy(() => import('../pages/Export/index'));
const Report = React.lazy(() => import('../pages/Report/index'));
const SignIn = React.lazy(() => import('../pages/SignIn'));
const ForgotPassword = React.lazy(() => import('../pages/SignIn/forgotPassword'));
const MFASignIn = React.lazy(() => import('../pages/SignIn/mfaSignIn'));
const StandardResistantRequirementsFumigationFormIndex = React.lazy(() => import('../pages/StandardResistantRequirementsFumigation'));
const VersionComparison = React.lazy(() => import('../pages/VersionComparison/index'));

const ROLE_ADMIN = "RoleAdmin";
const ROLE_INFO_HOLDER = "RoleInfoHolder";
const ROLE_GOLDENRULESINFOHOLDER = "RoleGoldenRulesInfoHolder";
const ROLE_APPROVER = "RoleApprover";
const ROLE_READ_ONLY = "RoleReadOnly";
const ROLE_ESGNANAGER = "RoleESGManager";
const ROLE_ESGAPPROVER = "RoleESGApprover";
const ROLE_ESGPERFORMANCEMANAGER = "RoleESGPerformanceManager";
const ROLE_GOLDENRULESAPPROVER = "RoleGoldenRulesApprover";
const ROLE_GLQCOMPLIANCESPECIALIST = "RoleGLQComplianceSpecialist";
const ROLE_SMEREVIEWER = "RoleSMEReviewer";
const ROLE_LEAFSOURCING = "RoleLeafSourcing";
const ROLE_LEAFQUALITY = "RoleLeafQuality";

const RoutesList = [
    {
        path: "/signin",
        label: "SignIn",
        component: SignIn,
        onlyGlobal: false
    },
    {
        path: "/Report/:operation/:moduleName/:versionIdentifier?",
        label: "Report",
        component: Report,
        isPrivate: true,
        allowedRoles: [ROLE_ADMIN, ROLE_APPROVER, ROLE_INFO_HOLDER, ROLE_READ_ONLY, ROLE_ESGAPPROVER, ROLE_ESGNANAGER, ROLE_ESGPERFORMANCEMANAGER, ROLE_GOLDENRULESAPPROVER, ROLE_GOLDENRULESINFOHOLDER, ROLE_GLQCOMPLIANCESPECIALIST, ROLE_SMEREVIEWER, ROLE_LEAFSOURCING, ROLE_LEAFQUALITY],
        showInSidebar: false,
        onlyGlobal: false
    },
    {
        path: "/signin/MultiFactorAuthentication",
        label: "MFASignIn",
        component: MFASignIn,
        onlyGlobal: false
    },
    {
        path: "/ForgotPassword/:token/:id",
        label: "Forgot Password",
        component: ForgotPassword,
        onlyGlobal: false
    },
    {
        path: "/populate",
        label: "SignIn",
        component: SignIn,
        onlyGlobal: false
    },
    {
        path: "/",
        label: "Home",
        component: Dashboard,
        isPrivate: true,
        showInSidebar: true,
        onlyGlobal: false
    },
    {
        path: "/Documents",
        label: "Documents Folder",
        component: IndexFolder,
        isPrivate: true,
        allowedRoles: [ROLE_ADMIN, ROLE_APPROVER, ROLE_INFO_HOLDER, ROLE_READ_ONLY, ROLE_ESGAPPROVER, ROLE_ESGNANAGER, ROLE_ESGPERFORMANCEMANAGER, ROLE_GOLDENRULESAPPROVER, ROLE_GOLDENRULESINFOHOLDER, ROLE_GLQCOMPLIANCESPECIALIST, ROLE_SMEREVIEWER, ROLE_LEAFSOURCING, ROLE_LEAFQUALITY],
        showInSidebar: true,
        onlyGlobal: false,
        childrens: [
            {
                path: "/Documents/:documentFolderID",
                label: "Documents Folder",
                component: IndexFolder,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN, ROLE_APPROVER, ROLE_INFO_HOLDER, ROLE_READ_ONLY, ROLE_ESGAPPROVER, ROLE_ESGNANAGER, ROLE_ESGPERFORMANCEMANAGER, ROLE_GOLDENRULESAPPROVER, ROLE_GOLDENRULESINFOHOLDER, ROLE_GLQCOMPLIANCESPECIALIST, ROLE_SMEREVIEWER, ROLE_LEAFSOURCING, ROLE_LEAFQUALITY],
                showInSidebar: false,
                onlyGlobal: false
            }
        ]
    },
    {
        path: "/discussionDashboard",
        label: "Discussion Dashboard",
        component: DiscussionDashboard,
        isPrivate: true,
        allowedRoles: [ROLE_ADMIN, ROLE_APPROVER, ROLE_INFO_HOLDER, ROLE_READ_ONLY, ROLE_ESGAPPROVER, ROLE_ESGNANAGER, ROLE_ESGPERFORMANCEMANAGER, ROLE_GOLDENRULESAPPROVER, ROLE_GOLDENRULESINFOHOLDER, ROLE_GLQCOMPLIANCESPECIALIST, ROLE_SMEREVIEWER, ROLE_LEAFSOURCING, ROLE_LEAFQUALITY],
        showInSidebar: true,
        onlyGlobal: false,
        childrens: [
            {
                path: "/discussionDashboard/:companyID/:reportYearID/:operationID/:moduleID",
                label: "Discussion Dashboard",
                component: DiscussionDashboard,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN, ROLE_APPROVER, ROLE_INFO_HOLDER, ROLE_READ_ONLY, ROLE_ESGAPPROVER, ROLE_ESGNANAGER, ROLE_ESGPERFORMANCEMANAGER, ROLE_GOLDENRULESAPPROVER, ROLE_GOLDENRULESINFOHOLDER, ROLE_GLQCOMPLIANCESPECIALIST, ROLE_SMEREVIEWER, ROLE_LEAFSOURCING, ROLE_LEAFQUALITY],
                showInSidebar: false,
                onlyGlobal: false
            }
        ]
    },
    {
        path: "/compareVersion",
        label: "Version Comparison",
        component: VersionComparison,
        isPrivate: true,
        allowedRoles: [ROLE_ADMIN, ROLE_APPROVER, ROLE_INFO_HOLDER, ROLE_READ_ONLY, ROLE_ESGAPPROVER, ROLE_ESGNANAGER, ROLE_ESGPERFORMANCEMANAGER, ROLE_GOLDENRULESAPPROVER, ROLE_GOLDENRULESINFOHOLDER, ROLE_GLQCOMPLIANCESPECIALIST, ROLE_SMEREVIEWER, ROLE_LEAFSOURCING, ROLE_LEAFQUALITY],
        showInSidebar: true,
        onlyGlobal: false,
        childrens: [
            {
                path: "/compareVersion/:companyID/:reportYearID/:operationID/:moduleID",
                label: "Version Comparison",
                component: VersionComparison,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN, ROLE_APPROVER, ROLE_INFO_HOLDER, ROLE_READ_ONLY, ROLE_ESGAPPROVER, ROLE_ESGNANAGER, ROLE_ESGPERFORMANCEMANAGER, ROLE_GOLDENRULESAPPROVER, ROLE_GOLDENRULESINFOHOLDER, ROLE_GLQCOMPLIANCESPECIALIST, ROLE_SMEREVIEWER, ROLE_LEAFSOURCING, ROLE_LEAFQUALITY],
                showInSidebar: false,
                onlyGlobal: false
            }
        ]
    },
    {
        label: "Exports",
        isMenu: true,
        isPrivate: true,
        allowedRoles: [ROLE_ADMIN, ROLE_APPROVER, ROLE_INFO_HOLDER, ROLE_READ_ONLY, ROLE_ESGAPPROVER, ROLE_ESGNANAGER, ROLE_ESGPERFORMANCEMANAGER, ROLE_GOLDENRULESAPPROVER, ROLE_GOLDENRULESINFOHOLDER, ROLE_GLQCOMPLIANCESPECIALIST, ROLE_SMEREVIEWER, ROLE_LEAFSOURCING, ROLE_LEAFQUALITY],
        showInSidebar: true,
        onlyGlobal: false,
        childrens: [
            {
                path: "/export",
                label: "Export",
                component: Export,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN, ROLE_APPROVER, ROLE_INFO_HOLDER, ROLE_READ_ONLY, ROLE_ESGAPPROVER, ROLE_ESGNANAGER, ROLE_ESGPERFORMANCEMANAGER, ROLE_GOLDENRULESAPPROVER, ROLE_GOLDENRULESINFOHOLDER, ROLE_GLQCOMPLIANCESPECIALIST, ROLE_SMEREVIEWER, ROLE_LEAFSOURCING, ROLE_LEAFQUALITY],
                showInSidebar: true
            },
        ]

    },

    {
        label: "Registers",
        isMenu: true,
        isPrivate: true,
        allowedRoles: [ROLE_ADMIN],
        showInSidebar: true,
        onlyGlobal: false,
        childrens: [
            {
                path: "/operation",
                label: "Form",
                component: OperationIndex,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                showInSidebar: true,
                onlyGlobal: true
            },
            {
                path: "/operation/edit/:id",
                label: "Edit Form",
                component: OperationForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/operation/new",
                label: "New Form",
                component: OperationForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/module",
                label: "Module",
                component: ModuleIndex,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                showInSidebar: true,
                onlyGlobal: true
            },
            {
                path: "/module/edit/:id",
                label: "Edit Module",
                component: ModuleForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/module/new",
                label: "New Module",
                component: ModuleForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/section",
                label: "Section",
                component: SectionIndex,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                showInSidebar: true,
                onlyGlobal: true
            },
            {
                path: "/section/edit/:id",
                label: "Edit Section",
                component: SectionForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/section/new",
                label: "New Section",
                component: SectionForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/subSection",
                label: "Sub Section",
                component: SubSectionIndex,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                showInSidebar: true,
                onlyGlobal: true
            },
            {
                path: "/subSection/edit/:id",
                label: "Edit Subsection",
                component: SubSectionForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/subSection/new",
                label: "New Subsection",
                component: SubSectionForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/kpi",
                label: "KPI",
                component: KPIIndex,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                showInSidebar: true,
                onlyGlobal: true
            },
            {
                path: "/kpi/edit/:id",
                label: "KPI",
                component: KPIForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/kpi/new",
                label: "KPI",
                component: KPIForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/subSectionKPI",
                label: "Sub Section KPI",
                component: SubSectionKPIIndex,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                showInSidebar: true,
                onlyGlobal: true
            },
            {
                path: "/subSectionKPI/edit/:id",
                label: "Edit Sub Section KPI",
                component: SubSectionKPIEdit,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/subSectionKPI/new",
                label: "New Subsection KPI",
                component: SubSectionKPIForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/answerTypeKPI",
                label: "Answer Type KPI",
                component: UnitMeasureIndex,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                showInSidebar: true,
                onlyGlobal: true
            },
            {
                path: "/answerTypeKPI/edit/:id",
                label: "Edit Answer Type KPI",
                component: UnitMeasureForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/answerTypeKPI/new",
                label: "New Answer Type KPI",
                component: UnitMeasureForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/tobaccoType",
                label: "Tobacco Type",
                component: TobaccoTypeIndex,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                showInSidebar: true,
                onlyGlobal: true
            },
            {
                path: "/tobaccoType/edit/:id",
                label: "Edit Tobacco Type",
                component: TobaccoTypeForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/tobaccoType/new",
                label: "New Tobacco Type",
                component: TobaccoTypeForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/ESGSubject",
                label: "ESG Subject",
                component: ESGSubjectIndex,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                showInSidebar: true,
                onlyGlobal: true
            },
            {
                path: "/ESGSubject/edit/:id",
                label: "Edit ESGSubject",
                component: ESGSubjectForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/ESGSubject/new",
                label: "New ESG Subject",
                component: ESGSubjectForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/reportYear",
                label: "Report Year",
                component: ReportYearIndex,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                showInSidebar: true,
                onlyGlobal: true
            },
            {
                path: "/reportYear/edit/:id",
                label: "Edit Report Year",
                component: ReportYearForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/reportYear/new",
                label: "New Report Year",
                component: ReportYearForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/migrate",
                label: "Migrate Structure",
                component: MigrateDashboard,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                showInSidebar: true,
                onlyGlobal: true
            },
            {
                path: "/notificationDeadlines",
                label: "Email Notification Deadlines",
                component: MailNotificationDeadlineFormIndex,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                showInSidebar: true,
                onlyGlobal: true
            },
        ]
    },
    {
        label: "Suppliers - Registers",
        isMenu: true,
        isPrivate: true,
        allowedRoles: [ROLE_ADMIN],
        showInSidebar: true,
        childrens: [
            {
                path: "/company",
                label: "Supplier",
                component: CompanyIndex,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                showInSidebar: true,
                onlyGlobal: true
            },
            {
                path: "/company/edit/:id",
                label: "Edit Supplier",
                component: CompanyForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/company/new",
                label: "New Supplier",
                component: CompanyForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/currencyType",
                label: "Currency Type",
                component: CurrencyTypeIndex,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                showInSidebar: true,
                onlyGlobal: true
            },
            {
                path: "/currencyType/edit/:id",
                label: "Edit Currency Type",
                component: CurrencyTypeForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/currencyType/new",
                label: "New Currency Type",
                component: CurrencyTypeForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/group",
                label: "Group",
                component: GroupIndex,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                showInSidebar: true,
                onlyGlobal: true
            },
            {
                path: "/group/edit/:id",
                label: "Edit Group",
                component: GroupForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/group/new",
                label: "New Group",
                component: GroupForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
        ]
    },
    {
        label: "Users - Registers and Logs",
        isMenu: true,
        isPrivate: true,
        allowedRoles: [ROLE_ADMIN],
        showInSidebar: true,
        childrens: [
            {
                path: "/user",
                label: "User",
                component: UserIndex,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                showInSidebar: true,
                onlyGlobal: true
            },
            {
                path: "/user/new",
                label: "New User",
                component: UserForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
            {
                path: "/user/edit/:id",
                label: "Edit User",
                component: UserForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                onlyGlobal: true
            },
        ]
    },
    {
        label: "Additional Data",
        isMenu: true,
        isPrivate: true,
        allowedRoles: [ROLE_ADMIN],
        showInSidebar: true,
        childrens: [

            {
                path: "/additionalDataDeadline",
                label: "Additional Data - Deadline",
                component: AdditionalDataDeadlineFormIndex,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                showInSidebar: true,
                onlyGlobal: true
            },
            {
                path: "/additionalDataTargets",
                label: "Additional Data - Targets",
                component: AdditionalDataTargetsFormIndex,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                showInSidebar: true,
                onlyGlobal: true
            },
            {
                path: "/subSectionKPI/defaultValues",
                label: "Default Values",
                component: AdditionalDataDefaultValuesForm,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                showInSidebar: true,
                onlyGlobal: true
            },
            {
                path: "/standardResistantRequirementsFumigation",
                label: "Standard Resistant Requirements Fumigation",
                component: StandardResistantRequirementsFumigationFormIndex,
                isPrivate: true,
                allowedRoles: [ROLE_ADMIN],
                showInSidebar: true,
                onlyGlobal: true
            },
        ]
    }
];

export default RoutesList;
